import styled from 'styled-components'
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {ErrorMessage } from 'formik'
import { ErrorMsg } from '../components/common/ErrorMsg';

const TextareaAutosizeStyled = styled(TextareaAutosize)`
    width: 100%;
    padding: 8px;
    font-size: 17px;
    border-radius: 2px;
    border: 1px solid #C4C4C4;
    color: #333;
    line-height: 1.5;
    outline: none;
    min-height: 80px;
`

const AreaField = ({ field, form, placeholder }) => {
    const {errors, touched} = form
    const {name} = field
    const isShowError = errors[name] && touched[name];
    return (
        <>
            <TextareaAutosizeStyled
                aria-label="minimum height"
                {...field}
                error={isShowError}

                placeholder={placeholder}

            />
            <ErrorMessage name={name} component={ErrorMsg}/>
        </>
    )
}

export default AreaField
